import {
  Container,
  Grid,
  Box,
  ButtonBase,
  Button,
  useTheme,
  Slide,
  Typography,
  Paper,
  Avatar,
  Card,
  CardMedia,
  CardActions,
  CardContent,
  Grow,
  makeStyles,
  useMediaQuery,
  Fade
} from "@material-ui/core";
import React, { useState, useEffect, useLayoutEffect, useRef } from "react";

import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Loading } from "../../components/shared/loading";
import { Link } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { TypingQuote } from "../../components/shared/TypingQuote";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import InstagramEmbed from './instaEmbedded'

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  nounderline: {
    "&:hover": { textDecoration: "none" },
  },
  heroSection: {
    position: "relative",
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    color: "#ffffff",
    textAlign: "center",
    padding: "32px 20px",
  },
  heroTitle: {
    fontSize: "clamp(1.6rem, 3.5vw, 2.2rem)",
    fontWeight: 600,
    letterSpacing: "-0.01em",
    lineHeight: 1.2,
    marginBottom: "12px",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 0.95rem)",
    fontWeight: 300,
    opacity: 0.9,
    maxWidth: "480px",
    margin: "0 auto 24px",
    lineHeight: 1.5,
  },
  heroButton: {
    backgroundColor: "#ffffff",
    color: "#6b1b6b",
    padding: "10px 28px",
    fontSize: "0.85rem",
    fontWeight: 600,
    borderRadius: "25px",
    textTransform: "none",
    boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
    }
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: "8px",
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#777777",
    textAlign: "center",
    maxWidth: "450px",
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  serviceCard: {
    position: "relative",
    borderRadius: 20,
    overflow: "hidden",
    width: "100%",
    height: 250,
    cursor: "pointer",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    [theme.breakpoints.down('sm')]: {
      height: 200,
      borderRadius: 16,
    },
    [theme.breakpoints.down('xs')]: {
      height: 170,
    },
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 20px 50px rgba(76, 0, 76, 0.2)",
    },
    "&:hover $serviceImg": {
      transform: "scale(1.08)",
      filter: "brightness(0.85)",
    },
    "&:hover $serviceGlass": {
      backdropFilter: "blur(16px)",
      background: "rgba(76, 0, 76, 0.75)",
      paddingBottom: 18,
      paddingTop: 18,
    },
    "&:hover $serviceAccent": {
      width: "40px",
    },
  },
  serviceImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    border: "none",
    transition: "all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)",
  },
  serviceGlass: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(76, 0, 76, 0.6)",
    backdropFilter: "blur(12px)",
    padding: "14px 16px",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    [theme.breakpoints.down('sm')]: {
      padding: "12px 14px",
    },
  },
  serviceAccent: {
    width: "24px",
    height: "2px",
    background: "rgba(255,255,255,0.6)",
    borderRadius: 2,
    marginBottom: 8,
    transition: "width 0.4s ease",
  },
  serviceTitle: {
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "#ffffff",
    lineHeight: 1.3,
    letterSpacing: "0.2px",
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.75rem",
    },
  },
  testimonialWrapper: {
    position: "relative",
    maxWidth: 520,
    margin: "0 auto",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "100%",
    },
  },
  testimonialSlide: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    opacity: 0,
    transform: "translateY(12px)",
    transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    pointerEvents: "none",
  },
  testimonialSlideActive: {
    opacity: 1,
    transform: "translateY(0)",
    position: "relative",
    pointerEvents: "auto",
  },
  testimonialCard: {
    textAlign: "center",
    padding: "0 20px",
  },
  testimonialAvatarWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 14,
  },
  testimonialAvatar: {
    width: 48,
    height: 48,
    border: "2px solid rgba(107, 27, 107, 0.15)",
    boxShadow: "0 4px 16px rgba(76, 0, 76, 0.1)",
    transition: "all 0.4s ease",
  },
  testimonialQuote: {
    fontSize: "0.88rem",
    lineHeight: 1.7,
    color: "#444444",
    fontStyle: "italic",
    fontWeight: 300,
    maxWidth: 440,
    margin: "0 auto 18px",
    position: "relative",
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.92rem",
    },
  },
  testimonialAccent: {
    width: 32,
    height: 2,
    background: "linear-gradient(90deg, #6b1b6b, #9b3b9b)",
    borderRadius: 2,
    margin: "0 auto 16px",
  },
  testimonialName: {
    fontWeight: 600,
    color: "#4c004c",
    fontSize: "0.9rem",
    letterSpacing: "0.3px",
  },
  testimonialProf: {
    color: "#999999",
    fontSize: "0.75rem",
    fontWeight: 400,
    marginTop: 2,
  },
  testimonialNav: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
    marginTop: 20,
  },
  testimonialArrow: {
    width: 34,
    height: 34,
    borderRadius: 10,
    border: "1px solid rgba(76, 0, 76, 0.12)",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.25s ease",
    color: "#6b1b6b",
    "&:hover": {
      background: "#6b1b6b",
      color: "#ffffff",
      borderColor: "#6b1b6b",
      transform: "scale(1.05)",
    },
    [theme.breakpoints.down('sm')]: {
      width: 36,
      height: 36,
      borderRadius: 10,
    },
  },
  testimonialDots: {
    display: "flex",
    gap: 6,
    alignItems: "center",
  },
  testimonialDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "rgba(76, 0, 76, 0.15)",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  testimonialDotActive: {
    width: 24,
    borderRadius: 4,
    background: "linear-gradient(90deg, #6b1b6b, #9b3b9b)",
  },
  partnersSection: {
    background: "linear-gradient(160deg, #4c004c 0%, #3a003a 40%, #2d002d 100%)",
    padding: "56px 0 48px",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "radial-gradient(circle at 50% 0%, rgba(155,59,155,0.15) 0%, transparent 60%)",
      pointerEvents: "none",
    },
  },
  partnersSectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#ffffff",
    textAlign: "center",
    marginBottom: 6,
    position: "relative",
    zIndex: 1,
  },
  partnersSectionSub: {
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.45)",
    textAlign: "center",
    maxWidth: 400,
    margin: "0 auto 36px",
    lineHeight: 1.5,
    position: "relative",
    zIndex: 1,
  },
  partnersMarquee: {
    display: "flex",
    overflow: "hidden",
    position: "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      width: 80,
      zIndex: 2,
    },
    "&::before": {
      left: 0,
      background: "linear-gradient(90deg, #4c004c, transparent)",
    },
    "&::after": {
      right: 0,
      background: "linear-gradient(270deg, #2d002d, transparent)",
    },
  },
  partnersTrack: {
    display: "flex",
    gap: 20,
    animation: "$marqueeScroll 30s linear infinite",
    "&:hover": {
      animationPlayState: "paused",
    },
    [theme.breakpoints.down('sm')]: {
      gap: 14,
    },
  },
  "@keyframes marqueeScroll": {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-50%)" },
  },
  partnerCard: {
    minWidth: 150,
    height: 80,
    borderRadius: 16,
    background: "rgba(255,255,255,0.95)",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 20px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    flexShrink: 0,
    "&:hover": {
      background: "#ffffff",
      boxShadow: "0 8px 28px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-3px)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 120,
      height: 65,
      borderRadius: 12,
      padding: "10px 16px",
    },
  },
  partnerImg: {
    maxWidth: "100%",
    maxHeight: "50px",
    objectFit: "contain",
    border: "none !important",
    [theme.breakpoints.down('sm')]: {
      maxHeight: "40px",
    },
  },
  // Video Testimonials
  videoSection: {
    padding: "36px 0 32px",
    background: "transparent",
  },
  videoSectionTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 4,
  },
  videoSectionSub: {
    fontSize: "0.78rem",
    color: "#888",
    textAlign: "center",
    maxWidth: 380,
    margin: "0 auto 24px",
    lineHeight: 1.5,
  },
  videoCard: {
    borderRadius: 20,
    overflow: "hidden",
    background: "#ffffff",
    border: "1px solid rgba(76,0,76,0.06)",
    boxShadow: "0 2px 16px rgba(76,0,76,0.04)",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    position: "relative",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 12px 36px rgba(76, 0, 76, 0.1)",
      borderColor: "rgba(76, 0, 76, 0.1)",
    },
  },
  videoCardHeader: {
    padding: "10px 16px 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  videoLabelRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  videoLabelDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #6b1b6b, #9b3b9b)",
  },
  videoLabelText: {
    fontSize: "0.62rem",
    fontWeight: 600,
    color: "#aaa",
    textTransform: "uppercase",
    letterSpacing: "1.2px",
  },
  videoBadge: {
    fontSize: "0.58rem",
    fontWeight: 600,
    color: "#bbb",
    background: "rgba(76,0,76,0.04)",
    padding: "2px 8px",
    borderRadius: 6,
    letterSpacing: "0.5px",
  },
  videoEmbed: {
    padding: "0 8px 8px",
    "& iframe": {
      borderRadius: "12px !important",
    },
    transform: "scale(0.92)",
    transformOrigin: "top center",
  },
  // Fallback grid for clients without marquee
  partnersGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 16,
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      gap: 12,
    },
  },
  ceoSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    position: "relative",
    overflow: "hidden",
  },
  ceoQuote: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: "700px",
    margin: "0 auto 12px",
    position: "relative",
    zIndex: 1,
  },
  ceoName: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
  ctaSection: {
    background: "linear-gradient(135deg, rgba(107, 27, 107, 0.04) 0%, rgba(107, 27, 107, 0.08) 100%)",
    borderRadius: "12px",
    padding: "32px 24px",
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: "8px",
  },
  ctaSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    maxWidth: "400px",
    margin: "0 auto 20px",
    lineHeight: 1.5,
  },
  ctaButton: {
    backgroundColor: "#6b1b6b",
    color: "#ffffff",
    padding: "10px 28px",
    fontSize: "0.85rem",
    fontWeight: 600,
    borderRadius: "25px",
    textTransform: "none",
    boxShadow: "0 2px 12px rgba(107, 27, 107, 0.25)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#5a155a",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 16px rgba(107, 27, 107, 0.35)",
    }
  },
  section: {
    padding: "40px 0",
  },
  sectionAlt: {
    padding: "40px 0",
    background: "#fafafa",
  },
  collabCard: {
    position: "relative",
    background: "#ffffff",
    borderRadius: 24,
    overflow: "hidden",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    boxShadow: "0 4px 24px rgba(0,0,0,0.04)",
    border: "1px solid rgba(76, 0, 76, 0.05)",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 20px 50px rgba(76, 0, 76, 0.12)",
      borderColor: "rgba(76, 0, 76, 0.1)",
    },
    "&:hover $collabLogoWrapper": {
      background: "rgba(250,245,250,1)",
    },
    "&:hover $collabLogo": {
      transform: "scale(1.08)",
    },
    "&:hover $collabArrow": {
      opacity: 1,
      transform: "translateX(0)",
      background: "#6b1b6b",
      color: "#fff",
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      borderRadius: 20,
    },
  },
  collabLogoWrapper: {
    width: 160,
    minWidth: 160,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,1)",
    transition: "all 0.4s ease",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      minWidth: "unset",
      height: 130,
    },
  },
  collabLogo: {
    maxWidth: "65%",
    maxHeight: "65%",
    objectFit: "contain",
    border: "none",
    transition: "transform 0.4s ease",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "45%",
      maxHeight: "70%",
    },
  },
  collabLogoFallback: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#4c004c",
    letterSpacing: "0.5px",
    textAlign: "center",
    lineHeight: 1.2,
  },
  collabContent: {
    flex: 1,
    padding: "24px 28px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    },
  },
  collabName: {
    fontSize: "1.05rem",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: 4,
  },
  collabRole: {
    fontSize: "0.68rem",
    fontWeight: 600,
    color: "#9b3b9b",
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    marginBottom: 10,
  },
  collabDesc: {
    fontSize: "0.82rem",
    color: "#666666",
    lineHeight: 1.6,
  },
  collabFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 14,
  },
  collabLink: {
    fontSize: "0.76rem",
    fontWeight: 500,
    color: "#6b1b6b",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#4c004c",
      textDecoration: "none",
      gap: 8,
    },
  },
  collabArrow: {
    width: 32,
    height: 32,
    borderRadius: 10,
    border: "1px solid rgba(76,0,76,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6b1b6b",
    opacity: 0,
    transform: "translateX(-8px)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    [theme.breakpoints.down('sm')]: {
      opacity: 1,
      transform: "translateX(0)",
    },
  },
}));

export const Home = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const [tests, setTests] = useState();
  const [videoTests, setVideoTests] = useState();
  const [cars, setCars] = useState();
  const [services, setServices] = useState();
  const [activeTest, setActiveTest] = useState(0);
  const testAutoRef = React.useRef(null);

  // Auto-rotate testimonials
  React.useEffect(() => {
    if (tests && tests.length > 1) {
      testAutoRef.current = setInterval(() => {
        setActiveTest((prev) => (prev + 1) % tests.length);
      }, 6000);
    }
    return () => { if (testAutoRef.current) clearInterval(testAutoRef.current); };
  }, [tests]);

  const goTestimonial = (dir) => {
    if (!tests) return;
    if (testAutoRef.current) clearInterval(testAutoRef.current);
    setActiveTest((prev) => (prev + dir + tests.length) % tests.length);
    testAutoRef.current = setInterval(() => {
      setActiveTest((prev) => (prev + 1) % tests.length);
    }, 6000);
  };
  const [clients, setClients] = useState();
  const [size, setSize] = useState(0);
  const [active, setActive] = useState(0);

  // Define breakpoints
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  const getBackgroundColor = (key) => {
    const itemsPerRow = isXl ? 4 : isLg ? 4 : isMd ? 3 : isSm ? 3 : 2;
    const rowNumber = Math.floor(key / itemsPerRow);
    const positionInRow = key % itemsPerRow;
    const isEvenRow = rowNumber % 2 === 0;
    const isEvenPosition = positionInRow % 2 === 0;
    if (isEvenRow) {
      return isEvenPosition ? 'rgba(76, 0, 76, 0.05)' : '#fff';
    } else {
      return isEvenPosition ? '#fff' : 'rgba(76, 0, 76, 0.05)';
    }
  };

  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 1);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        handleClick();
      }
    });

    Axios.get("/api/gethomedata", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setTests(res.data.tests);
        setCars(res.data.slides);
        setServices(res.data.services);
        setClients(res.data.clients);
        setVideoTests(res.data.videotests)
        setIsloading(false);
      }
    });
  };

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>

      {isloading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <Container maxWidth="lg">
              <Fade in={true} timeout={1000}>
                <Box className={classes.heroContent}>
                  <Typography className={classes.heroTitle}>
                    Transform Your Business<br />
                    <span style={{ fontWeight: 400 }}>With Innovative IT Solutions</span>
                  </Typography>
                  <Typography className={classes.heroSubtitle}>
                    We craft cutting-edge digital experiences that drive growth, 
                    enhance efficiency, and deliver measurable results for your business.
                  </Typography>
                  <Button 
                    className={classes.heroButton}
                    component={Link}
                    to="/our-services"
                    endIcon={<ArrowForwardIcon />}
                  >
                    Explore Our Services
                  </Button>
                </Box>
              </Fade>
            </Container>

            {/* Carousel overlay */}
            {cars && (
              <Box sx={{ 
                position: "absolute", 
                bottom: 0, 
                left: 0, 
                right: 0, 
                opacity: 0.15,
                pointerEvents: "none"
              }}>
                <Carousel
                  animation="slide"
                  autoPlay={true}
                  showIndicators={false}
                  showArrows={false}
                  centerMode={true}
                  centerSlidePercentage={size < 960 ? 100 : 50}
                  infiniteLoop
                  showThumbs={false}
                  transitionTime={1200}
                  statusFormatter={() => ``}
                >
                  {cars.map((item, i) => (
                    <div key={i}>
                      <img src={item.slide} alt={item.text} style={{ width: "100%" }} />
                    </div>
                  ))}
                </Carousel>
              </Box>
            )}
          </Box>

          {/* Services Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Expertise
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Delivering excellence through tailored IT solutions that transform businesses
                  </Typography>
                </Box>
              </Slide>

              {services && (
                <Grid container spacing={3}>
                  {services.map((service, key) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={key}>
                      <Grow in={true} timeout={600 + key * 100}>
                        <ButtonBase
                          className={classes.nounderline}
                          component={Link}
                          to={"/service-details/" + service.serv_name.split(" ").join("-") + "/" + service.serv_id}
                          style={{ width: "100%", height: "100%" }}
                        >
                          <Box className={classes.serviceCard}>
                            <img
                              src={"/static/services/" + service.serv_image}
                              alt={service.serv_name}
                              className={classes.serviceImg}
                            />
                            <Box className={classes.serviceGlass}>
                              <Box className={classes.serviceAccent} />
                              <Typography className={classes.serviceTitle}>
                                {service.serv_name}
                              </Typography>
                            </Box>
                          </Box>
                        </ButtonBase>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Container>
          </Box>

          {/* Collaborations Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Collaborations
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Strategic partnerships driving innovation and growth
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={3} justifyContent="center">
                {/* ScaleMe.in */}
                <Grid item xs={12} sm={6}>
                  <Grow in={true} timeout={600}>
                    <Box className={classes.collabCard}>
                      <Box className={classes.collabLogoWrapper}>
                        <img
                          src="/static/scaleme.png"
                          alt="ScaleMe.in"
                          className={classes.collabLogo}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                        />
                        <Typography className={classes.collabLogoFallback} style={{ display: 'none' }}>Scale<br/>Me</Typography>
                      </Box>
                      <Box className={classes.collabContent}>
                        <Typography className={classes.collabName}>
                          ScaleMe.in
                        </Typography>
                        <Typography className={classes.collabRole}>
                          AI Tech Advisory Partner
                        </Typography>
                        <Typography className={classes.collabDesc}>
                          Arawinz serves as AI Technology Advisor for ScaleMe, building AI-based networking, communication, and automation solutions.
                        </Typography>
                        <Box className={classes.collabFooter}>
                          <a
                            href="https://scaleme.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.collabLink}
                          >
                            Visit ScaleMe.in
                          </a>
                          <a
                            href="https://scaleme.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                          >
                            <Box className={classes.collabArrow}>
                              <ArrowForwardIcon style={{ fontSize: 16 }} />
                            </Box>
                          </a>
                        </Box>
                      </Box>
                    </Box>
                  </Grow>
                </Grid>

                {/* Ziplo.ai */}
                <Grid item xs={12} sm={6}>
                  <Grow in={true} timeout={800}>
                    <Box className={classes.collabCard}>
                      <Box className={classes.collabLogoWrapper}>
                        <img
                          src="/static/zaplo.png"
                          alt="Ziplo.ai"
                          className={classes.collabLogo}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                        />
                        <Typography className={classes.collabLogoFallback} style={{ display: 'none' }}>Ziplo<br/>.ai</Typography>
                      </Box>
                      <Box className={classes.collabContent}>
                        <Typography className={classes.collabName}>
                          Ziplo.ai
                        </Typography>
                        <Typography className={classes.collabRole}>
                          Enterprise AI Agent Testing Partner
                        </Typography>
                        <Typography className={classes.collabDesc}>
                          Partnered with Ziplo.ai to help enterprises test, evaluate, govern, and deploy AI agents with reliability and compliance.
                        </Typography>
                        <Box className={classes.collabFooter}>
                          <a
                            href="https://ziplo.ai"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.collabLink}
                          >
                            Visit Ziplo.ai
                          </a>
                          <a
                            href="https://ziplo.ai"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                          >
                            <Box className={classes.collabArrow}>
                              <ArrowForwardIcon style={{ fontSize: 16 }} />
                            </Box>
                          </a>
                        </Box>
                      </Box>
                    </Box>
                  </Grow>
                </Grid>

                {/* CodeSquare Labs - commented out for now
                <Grid item xs={12} sm={6} md={4}>
                  <Grow in={true} timeout={1000}>
                    <Box className={classes.collabCard}>
                      <Box className={classes.collabLogoWrapper}>
                        <img
                          src="/static/csl.png"
                          alt="CodeSquare Labs"
                          className={classes.collabLogo}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                        />
                        <Typography className={classes.collabLogoFallback} style={{ display: 'none' }}>Code<br/>Square</Typography>
                      </Box>
                      <Typography className={classes.collabName}>
                        CodeSquare Labs
                      </Typography>
                      <Typography className={classes.collabRole}>
                        Technology Partner
                      </Typography>
                      <Typography className={classes.collabDesc}>
                        Arawinz is the technology partner for CodeSquare Labs, an IT & digital marketing agency. 
                        CSL manages sales, branding, and digital marketing, while Arawinz builds and maintains 
                        web platforms, mobile apps, and backend systems.
                      </Typography>
                      <a
                        href="https://codesquarelabs.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.collabLink}
                      >
                        Visit CodeSquareLabs.com <ArrowForwardIcon style={{ fontSize: 16 }} />
                      </a>
                    </Box>
                  </Grow>
                </Grid>
                */}
              </Grid>
            </Container>
          </Box>

          {/* Testimonials Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Client Stories
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover how our solutions have made a difference
                  </Typography>
                </Box>
              </Slide>

              {tests && tests.length !== 0 && (
                <Box className={classes.testimonialWrapper}>
                  {tests.map((item, i) => (
                    <Box
                      key={i}
                      className={`${classes.testimonialSlide} ${i === activeTest ? classes.testimonialSlideActive : ''}`}
                    >
                      <Box className={classes.testimonialCard}>
                        <Box className={classes.testimonialAvatarWrapper}>
                          <Avatar
                            alt={item.test_name}
                            src={"/static/testms/" + item.test_image}
                            className={classes.testimonialAvatar}
                          />
                        </Box>
                        <Typography className={classes.testimonialQuote}>
                          "{item.test_msg}"
                        </Typography>
                        <Box className={classes.testimonialAccent} />
                        <Typography className={classes.testimonialName}>
                          {item.test_name}
                        </Typography>
                        <Typography className={classes.testimonialProf}>
                          {item.test_prof}
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                  {/* Navigation */}
                  <Box className={classes.testimonialNav}>
                    <Box className={classes.testimonialArrow} onClick={() => goTestimonial(-1)}>
                      <ChevronLeftIcon style={{ fontSize: 20 }} />
                    </Box>
                    <Box className={classes.testimonialDots}>
                      {tests.map((_, i) => (
                        <Box
                          key={i}
                          className={`${classes.testimonialDot} ${i === activeTest ? classes.testimonialDotActive : ''}`}
                          onClick={() => {
                            setActiveTest(i);
                            if (testAutoRef.current) clearInterval(testAutoRef.current);
                            testAutoRef.current = setInterval(() => {
                              setActiveTest((prev) => (prev + 1) % tests.length);
                            }, 6000);
                          }}
                        />
                      ))}
                    </Box>
                    <Box className={classes.testimonialArrow} onClick={() => goTestimonial(1)}>
                      <ChevronRightIcon style={{ fontSize: 20 }} />
                    </Box>
                  </Box>
                </Box>
              )}
            </Container>
          </Box>

          {/* Video Testimonials Section */}
          {videoTests && videoTests.length > 0 && (
            <Box className={classes.videoSection}>
              <Container maxWidth="lg">
                <Slide direction="up" in={true} timeout={800}>
                  <Box>
                    <Typography className={classes.videoSectionTitle}>
                      Video Testimonials
                    </Typography>
                    <Typography className={classes.videoSectionSub}>
                      Witness the journey and success of our clients in their own words
                    </Typography>
                  </Box>
                </Slide>

                <Grid container spacing={3} justifyContent="center">
                  {videoTests.map((videotest, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                      <Grow in={true} timeout={800 + i * 200}>
                        <Box className={classes.videoCard}>
                          <Box className={classes.videoCardHeader}>
                            <Box className={classes.videoLabelRow}>
                              <Box className={classes.videoLabelDot} />
                              <Typography className={classes.videoLabelText}>
                                Client Story
                              </Typography>
                            </Box>
                            <Typography className={classes.videoBadge}>
                              #{String(i + 1).padStart(2, '0')}
                            </Typography>
                          </Box>
                          <Box className={classes.videoEmbed}>
                            <InstagramEmbed url={videotest.video_url} />
                          </Box>
                        </Box>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              </Container>
            </Box>
          )}

          {/* Trusted Partners Section */}
          <Box className={classes.partnersSection}>
            <Typography className={classes.partnersSectionTitle}>
              Trusted Partners
            </Typography>
            <Typography className={classes.partnersSectionSub}>
              Celebrating successful partnerships with industry leaders
            </Typography>

            {clients && clients.length > 0 && (
              <Box className={classes.partnersMarquee}>
                <Box className={classes.partnersTrack}>
                  {/* Double the logos for seamless infinite scroll */}
                  {[...clients, ...clients].map((client, key) => (
                    <a
                      key={key}
                      href={client.site_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Box className={classes.partnerCard}>
                        <img
                          src={"/static/clients/" + client.image_url}
                          alt={client.name}
                          className={classes.partnerImg}
                        />
                      </Box>
                    </a>
                  ))}
                </Box>
              </Box>
            )}
          </Box>

          {/* CEO Quote Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={1000}>
                <Box className={classes.ceoSection}>
                  <FormatQuoteIcon style={{ 
                    fontSize: 40, 
                    color: "rgba(255, 255, 255, 0.15)",
                    display: "block",
                    margin: "0 auto 16px"
                  }} />
                  <TypingQuote
                    text={`"At Arawinz, we blend innovation with dedication to deliver exceptional solutions. Our team's journey is marked by a relentless pursuit of excellence and a deep commitment to understanding and fulfilling our clients' needs. Together, we are more than just a team - we are architects of the future, crafting a smarter, more connected world."`}
                    className={classes.ceoQuote}
                  />
                  <Typography className={classes.ceoName}>
                    — Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Slide>
            </Container>
          </Box>

          {/* CTA Section */}
          <Box style={{ padding: "40px 0 80px" }}>
            <Container maxWidth="md">
              <Slide direction="up" in={true} timeout={1000}>
                <Box className={classes.ctaSection}>
                  <Typography className={classes.ctaTitle}>
                    Ready to Transform Your Business?
                  </Typography>
                  <Typography className={classes.ctaSubtitle}>
                    Let's discuss how we can help you achieve your goals with our innovative solutions.
                  </Typography>
                  <Button 
                    className={classes.ctaButton}
                    component={Link}
                    to="/get-in-touch"
                    startIcon={<PhoneIcon />}
                  >
                    Get In Touch
                  </Button>
                </Box>
              </Slide>
            </Container>
          </Box>
        </>
      )}
    </div>
  );
};

